module.exports = __webpack_public_path__ + "static/media/logo-01.3613e661.png";